import dayjs from "dayjs";

export const kendoDefaultDateFormatddMMyyyy = "dd/MM/yyyy";
export const defaultDateFormatDDMMYYYYSeperatedBySlash = "DD/MM/YYYY";
export const defaultDateFormatDDMMYYYYSeperatedByUnderscore = "DD_MM_YYYY";
export const defaultDateFormatDDMMYYYYSeperatedByPeriod = "DD.MM.YYYY";
export const defaultApiDateFormatYYYYMMDD = "YYYY-MM-DD";
export const defaultTimeFormatHHmmss = "HH:mm:ss";

export const placeholderDateFormat = {
  day: "dd",
  month: "mm",
  year: "yyyy",
};

export const ensureDateOrUndefined = (date: string | Date | undefined) =>
  date ? new Date(date) : undefined;

export const convertToDateFormat = (date: string | Date) => {
  return typeof date === "string" ? new Date(date) : date;
};

export const formatDateTo = (date: Date | undefined, dateFormat: string) => {
  if (date) return dayjs(date).format(dateFormat);

  return "-";
};

export const formatDateForFilename = (date?: Date) => {
  if (date) return dayjs(date).format(defaultDateFormatDDMMYYYYSeperatedByUnderscore);
  return dayjs().format(defaultDateFormatDDMMYYYYSeperatedByUnderscore);
};
